<template>
  <Layout>
    <div v-if="id" style="min-height:500px;" class="mt-5">
      <PostItem :id="id" :key="id" />
    </div>
    <div v-else>
      <b-row class="m-5 mb-3">
        <b-col>
          <h1 class="mt-5 mb-3">Últimas Noticias {{id}}</h1>
        </b-col>
      </b-row>
      <b-row tag="article" v-if="loading">
        <div class="col m-5 text-center">
          <b-spinner label="Spinning"></b-spinner>
        </div>
      </b-row>
      <b-row tag="article" v-else class="m-5 text-left">
        <b-col cols="6">
          <div
            style="position:relative; position: relative; width: 100%; max-height: 400px; overflow: hidden;"
          >
            <b-img :src="thumbnail(destacado)" class="img-fluid" style="width:100%; height:auto" />
          </div>

          <div style="padding:15px">
            <b-link :to="`/noticias/${destacado.id}`" class="text-dark">
              <h3 class="block-title" v-html="destacado.title.rendered" />
            </b-link>
            <!-- <p class="date" style="color:black">{{formatDate(destacado.date)}}</p> -->
            <b-button
              :to="`/noticias/${destacado.id}`"
              variant="secondary"
              shadow-sm
              style="color:#fff; border-radius:50px; text-transform:uppercase; font-size:14px"
              class="shadow mt-2"
            >
              Ver más
              <b-icon-arrow-right></b-icon-arrow-right>
            </b-button>
          </div>
        </b-col>
        <b-col cols="6">
          <b-row v-for="post in posts" v-bind:key="post.id">
            <b-col
              class="mb-3"
              style="position:relative; position: relative; width: 100%; max-height: 180px;overflow: hidden;"
            >
              <b-img :src="thumbnail(post)" class="img-fluid" style="width:100%; height:auto" />
            </b-col>
            <b-col>
              <b-link :to="`/noticias/${post.id}`" class="text-dark">
                <h3 class="block-title" v-html="post.title.rendered" />
              </b-link>
              <!-- <p class="date">{{formatDate(post.date)}}</p> -->
              <b-button
                :to="`/noticias/${post.id}`"
                variant="secondary"
                shadow-sm
                style="color:#fff; border-radius:50px; text-transform:uppercase; font-size:14px"
                class="shadow mt-2"
              >
                Ver más
                <b-icon-arrow-right></b-icon-arrow-right>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-5" v-if="showList">
        <b-col>
          <h3 class="mb-0">Más noticias</h3>
        </b-col>
      </b-row>
      <b-row class="p-5"  v-if="showList">
        <b-col md="4" v-for="post in list" v-bind:key="post.id" class="p-0 border">
          <b-img :src="thumbnail(post)" class="img-fluid" style="width:100%; height:auto" />
          <div class="p-3"><b-link :to="`/noticias/${post.id}`" class="text-dark ">
            <h3 class="block-title" v-html="post.title.rendered" />
          </b-link>
          <!-- <p class="date">{{formatDate(post.date)}}</p> -->
          <b-button
            :to="`/noticias/${post.id}`"
            variant="secondary"
            shadow-sm
            style="color:#fff; border-radius:50px; text-transform:uppercase; font-size:14px"
            class="shadow mt-2"
          >
            Ver más
            <b-icon-arrow-right></b-icon-arrow-right>
          </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import PostItem from "../components/PostItem";
import config from "../../public/data/config.json";
export default {
  metaInfo: {
    title: "Noticias"
  },
  components: {
    PostItem
  },
  methods: {
    formatDate(date) {
      return moment(date, "DD-MM-YYYY")
        .locale("es_ve")
        .format("MMMM DD YYYY");
    },
    thumbnail(post) {
      if (post) {
        if (typeof post._embedded["wp:featuredmedia"] === "undefined") {
          return "https://via.placeholder.com/350x250";
        } else {
          return post._embedded["wp:featuredmedia"]["0"].source_url;
        }
      } else {
        return null;
      }
    },
    buildData() {
      const endpost = this.results.data.length;
      this.destacado = this.results.data.slice(0, 1)[0];
      this.posts = this.results.data.slice(1, 4);
      this.list = this.results.data.slice(4, endpost);
      this.showList = this.list.length > 3; 
      this.loading = false;
    },
    async fetchData() {
      try {
        this.loading = true;
        this.results = await axios.get(
          config.URL +
            "/posts?_embed&per_page=50&filter[orderby]=date&order=asc"
        );

        localStorage.results = JSON.stringify(this.results);
        this.buildData();
      } catch (error) {
        console.log(error);
      }
    }
  },
  data() {
    return {
      results: null,
      destacado: null,
      posts: null,
      loading: false,
      list: null,
      id: null,
      showList: false
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
    let now = Math.floor(Date.now() / 1000);
    if (localStorage.updated) {
      let haspassed = now - localStorage.updated;
      if (haspassed > 10) {
        localStorage.clear();
        this.fetchData();
      } else {
        if (localStorage.results) {
          this.results = JSON.parse(localStorage.results);
          this.buildData();
        } else {
          this.fetchData();
        }
      }
    } else {
      localStorage.updated = now;
      this.fetchData();
    }
  }
};
</script>
<style scoped>
.block-title {
  font-style: normal;
  font-weight: 800;
  color: black;
  font-size: 18px;
}
.date {
  font-size: 14px;
  color: #969696;
  font-weight: 600;
}
</style>
